import React from 'react';
import { Box, Theme, useTheme } from '@mui/material';
import * as d3 from 'd3';

interface SentimentColorProps {
  // Positivity should be a value from 0.0 to 1.0
  positivity: number;
  children?: React.ReactNode;
}

export function getSentimentColorFromPositivity(theme: Theme, positivity: number): string {
  const namedColors = theme.colors.namedColors;
  const colorLerp = d3.interpolateRgbBasis([ namedColors.negative, namedColors.mixed, namedColors.positive ]);
  return positivity === null ? theme.colors.namedColors.neutral : colorLerp(positivity);
}

// Tooltip content component
export default function SentimentColor(props: SentimentColorProps): JSX.Element {
  const theme = useTheme();
  const sentimentColor = getSentimentColorFromPositivity(theme, props.positivity);

  return (
    <Box sx={{ color: sentimentColor, display:"inline" }}>
      {props.children}
    </Box>
  );
};
